// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageFull_image__1dXiN","Md":"ImageFull_Md__X-mGq","Sm":"ImageFull_Sm__L2ELP","Lg":"ImageFull_Lg__3cVoj","Xs":"ImageFull_Xs__2sO7A"};